import { COHORTS, useCohort } from "@/components/user-context";

import { LoggedInJiraNewUser } from "../components/logged-in-jira-new-user";

import { LoggedInJiraPremiumExistingUser } from "./existing-user";
import { LoggedInJiraPremiumUpgradeEligibleUser } from "./upgrade-eligible-user";

export const LoggedInJiraPremium = () => {
    const cohort = useCohort();

    if (cohort === COHORTS.NEW_USER) {
        return <LoggedInJiraNewUser />;
    }

    if (cohort === COHORTS.UPGRADE_ELIGIBLE_USER) {
        return <LoggedInJiraPremiumUpgradeEligibleUser />;
    }

    if (cohort) {
        return <LoggedInJiraPremiumExistingUser />;
    }

    return null;
};
